import { useEffect, useState } from "react";
import logo from "../../assets/images/logo.svg";
export default function Spinner({mainScreen}: {mainScreen?: boolean}) {

    const randomTips = [
        "We are all made of stardust",
        "The first computer virus was created in 1983",
        "The first computer mouse was invented in 1964",
        "The first computer bug was an actual bug",
        "First is the worst, second is the best",
    ]

    const [selectedRandomTip, setSelectedRandomTip] = useState(randomTips[Math.floor(Math.random() * randomTips.length)]);

    useEffect(() => {
        if(!mainScreen) return;
        const interval = setInterval(() => {
            setSelectedRandomTip(randomTips[Math.floor(Math.random() * randomTips.length)]);
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex justify-center items-center h-screen select-none">
            {mainScreen && (
                <div className="items-center justify-center flex flex-col">
                    <img src={logo} draggable={false} className="h-32 w-32 animate-pulse" />

                    <div className="mt-4 items-center flex flex-col">
                        <h1 className="text-sm font-bold italic text-gray-100">Did you know?</h1>
                        <p className="text-xs text-gray-300">{selectedRandomTip}</p>
                    </div>
                </div>
            )} 
            {!mainScreen && ( 
                <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
            )}
        </div>
    );
}
